/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 30/11/2023
 */
import BaseObject from "@shared/BaseObject.js";

export default class AssignStats extends BaseObject {

	clientsCount: number = 0
	filesCount: number = 0
	formsCount: number = 0
	legalDocsTemplateCount: number = 0
	signedLegalDocsCount: number = 0
	toolsCount: number = 0
	sessionTypesCount: number = 0


	constructor() {
		super();
	}


	getClientsCount() {
		return this.clientsCount;
	}

	getResourcesCount() {
		return this.filesCount + this.formsCount + this.legalDocsTemplateCount + this.signedLegalDocsCount + (this.toolsCount || 0);
	}

	getSessionTypesCount() {
		return this.sessionTypesCount;
	}





}
